import { Component, Input, OnInit } from '@angular/core';
import { ECharts, EChartOption, EChartTitleOption } from 'echarts';
import { fromEvent } from 'rxjs';
import { debounceTime, windowWhen } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { IndexPieService } from './index-pie.service';
import { ChartOptionService } from '../../service/chart-option.service';
import { ChartResizeService } from '../../service/chart-resize.service';

@Component({
  selector: 'bcac-index-pie',
  templateUrl: './index-pie.component.html',
  styleUrls: ['./index-pie.component.scss']
})
export class IndexPieComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private indexPieService: IndexPieService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService
  ) { }

  chartTitle = {
    show: true,
    label: '图表标题'
  }

  // 布局设置
  cardPadding = "1rem";
  cardBgColor = "#fff";
  chartTitleColor = "";

  // echart图表元素
  chartBackgroundColor: string = "#FFF";
  chartColors: string[] = this.chartOptionService.getChartColors('default');
  chartTitles = this.indexPieService.getDefaultChartTitle();
  chartTextStyle = this.chartOptionService.getTextStyle();
  pieSeries: EChartOption.SeriesPie = this.indexPieService.getIndexPieSeries();
  chartSeriesList: EChartOption.Series[] = [];


  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    title: this.chartTitles,
    series: this.chartSeriesList,
    color: this.chartColors,
    textStyle: this.chartTextStyle
  };

  initOpts = this.chartOptionService.getInitOpts();
  optionInit: ECharts;
  onOptionInit(ec) {
    this.optionInit = ec;
  }

  @Input()
  set bcacDarkMode(darkMode: boolean) {
    if (darkMode == true) {
      this.indexPieService.changeChartTitleDark(this, darkMode);
      this.indexPieService.chartBackgroundColorDarkMode(this.chartOption);
      this.indexPieService.colorsDarkMode(this.chartColors);
      this.indexPieService.seriesDarkMode(this.pieSeries);
      this.indexPieService.chartTitleDarkMode(this.chartTitles);
    }
  }

  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.indexPieService.setSmallModePadding(this);
    }
  }

  // 标题开关
  @Input()
  set bcacTitleSwithch(titleSwitch: boolean) {
    this.chartTitle.show = titleSwitch;
  }

  // 标题
  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }


  @Input()
  set bcacColors(colorList: string[]) {
    this.indexPieService.chartColorsChange(this.chartColors, colorList);
  }

  @Input()
  set bcacRadius(radius: string[]) {
    this.indexPieService.changeChartRadius(this.pieSeries, radius)
  }

  // 选择图形方向 true:顺时针 
  @Input()
  set bcacClockWise(clockWise: boolean) {
    this.indexPieService.changePieClockWise(clockWise, this.pieSeries);
  }

  @Input()
  set bcacChartData(chartData: any) {
    this.indexPieService.buildSeries(chartData, this.chartSeriesList, this.pieSeries)
    this.updateOption();
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }


  @Input()
  set bcacChartTitle(chartTitle) {
    this.indexPieService.setChartTitle(chartTitle, this.chartTitles)
  }

  @Input()
  set bcacCenter(center:number|string|Array<any>) {
    this.indexPieService.setPieCenter(center, this.pieSeries)
  }

   // 加载等待
   _bcacChartLoading: boolean = false
   @Input()
   set bcacChartLoading(loading: boolean) {
     this._bcacChartLoading = loading;
   }

  legendChange($event) {
    this.indexPieService.topLegendChange($event, this.optionInit);
  }


  options;
  // echart配置项  
  initEchart() {
    this.options = this.chartOption;
  }

  updateOption() {
    if (this.optionInit) {
      this.optionInit.setOption(this.options, true)
    }
  }

  ngOnInit() {
    this.initEchart();
    this.updateOption();
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdaptPieWithRichLabel(this.optionInit, this.options)
    })
  }

}
